import * as React from 'react';
import { getDividerClassNames } from './VerticalDivider.classNames';
import { getTheme } from '../../Styling';
export var VerticalDivider = function (props) {
    var theme = getTheme();
    var classNames = props.getClassNames ? props.getClassNames(theme) : getDividerClassNames(theme);
    return (React.createElement("span", { className: classNames.wrapper },
        React.createElement("span", { className: classNames.divider })));
};
//# sourceMappingURL=VerticalDivider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Divider/VerticalDivider.js
// module id = 295
// module chunks = 0